import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useState } from "react";
import Example from "./app/components/exampleNav";
import { routes } from "./routes";
import { ModalProvider } from './app/hooks/useModal';
import Modal from './app/components/common/modal';
import CookieToaster from "./app/components/cookieToaster";
import { usePageMeta } from "./app/hooks/usePageMeta";



function App() {
  const [showOwner, setShowOwner] = useState(false);
  const location = useLocation();
  usePageMeta();
  const isVsOps = location.pathname.startsWith("/vs-ops");
  const getRoutes = (routes) => {
    return routes.map((rote, ind) => { return <Route path={rote.path} element={rote.element} key={ind} /> })
  }

  return (
    <div className={`flex justify-center relative${isVsOps ? " vs-ops-root" : ""}`}>
      <div className="flex flex-col items-center w-full max-w-7xl">
        {!isVsOps ? (
        <header className="bg-[#f7f8fa] dark:bg-[#222222] rounded-b-2xl container ">
          <Example />
        </header >
        ) : null}
        <main className={`h-full w-full${isVsOps ? "" : " container"}`}>
          <ModalProvider>
            <Routes>
              {getRoutes(routes)}
            </Routes>
            <Modal />
          </ModalProvider>
        </main>
        {!isVsOps ? (
        <footer className="items-center relative bg-[#f7f8fa] dark:bg-[#222222] rounded-2xl container">
          <p className="mx-2 my-1 text-center text-sm text-gray-500 ">Email: {process.env.REACT_APP_SUPPORT_EMAIL}</p>
          <p className="mx-2 my-1 text-center text-sm text-gray-500">
            Техподдержка:{" "}
            <a
              href={process.env.REACT_APP_SUPPORT_TG_URL}
              className="text-blue-700 dark:text-indigo-400"
              target="_blank"
              rel="noreferrer"
            >
              Telegram
            </a>
            {" / "}
            <a
              href={process.env.REACT_APP_SUPPORT_URL}
              className="text-blue-700 dark:text-indigo-400"
              target="_blank"
              rel="noreferrer"
            >
              ВКонтакте
            </a>
          </p>
          <div className="mx-2 my-1 text-center text-sm text-gray-500">
            <div>ООО "Нивад"</div>
            <div>Рег номер 309244-3301-ООО</div>
            <div>
              Юридический адрес: Кыргызская Республика, Чуйская обл., Бишкек,
              Первомайский район, ул. Токтогула, 141
            </div>
          </div>
          <div className="mx-2 my-1 mb-2 flex flex-wrap justify-center gap-x-4 gap-y-1 text-center text-sm text-gray-500">
            <Link
              to="/offer#offer"
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              Договор публичной оферты
            </Link>
            <Link
              to="/offer#rules"
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              Правила пользования
            </Link>
            <Link
              to="/offer#privacy"
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              Политика конфиденциальности
            </Link>
          </div>
          <a href="https://metrika.yandex.ru/stat/?id=93997310&amp;from=informer"
            target="_blank" rel="noreferrer"><img src="https://informer.yandex.ru/informer/93997310/3_0_FFFFFFFF_EFEFEFFF_0_pageviews"
              style={{ width: "81px", height: "31px", border: "0" }} alt="Яндекс.Метрика" title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)" className="ym-advanced-informer hidden md:block absolute bottom-0 right-0 bott m-[2px]" data-cid="93997310" data-lang="ru" /></a>
          <button
            type="button"
            className="mx-2 my-1 text-center text-[10px] text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
            onClick={() => setShowOwner((prev) => !prev)}
          >
            владелец сайта
          </button>
          {showOwner && (
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 rounded-md border border-gray-200 bg-white px-3 py-2 text-[11px] text-gray-700 shadow-md dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200">
              ИП Казаков Игорь Евгеньевич / ИНН: 660901997402 / ОГРНИП: 322665800098991
            </div>
          )}
        </footer>
        ) : null}
      </div >
      {!isVsOps ? <CookieToaster /> : null}
    </div>
  );
}

export default App;
